import { render } from "./PcHome.vue?vue&type=template&id=59082399&scoped=true"
import script from "./PcHome.vue?vue&type=script&lang=js"
export * from "./PcHome.vue?vue&type=script&lang=js"

import "./PcHome.vue?vue&type=style&index=0&id=59082399&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59082399"]])

export default __exports__